import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=be68c37a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be68c37a')) {
      api.createRecord('be68c37a', component.options)
    } else {
      api.reload('be68c37a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=be68c37a&", function () {
      api.rerender('be68c37a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z5TIyS6XHmfv/JS/comp/ImgFallback.vue"
export default component.exports